// src/components/WhyUs.jsx
import Reveal from "./Reveal";

export default function WhyUs() {
  const IMG = "/feature/network.jpg"; // your existing file

  const items = [
    {
      title: "Experienced Network",
      desc: "Partnered with top national mass-tort firms.",
      img: "/feature/experienced-network.jpg",
      alt: "Nationwide attorney network connected across the U.S.",
    },
    {
      title: "No Upfront Costs",
      desc: "You pay nothing unless we win your case.",
      img: "/feature/no-upfront-costs.jpg",
      alt: "No upfront fees—contingency basis.",
    },
    {
      title: "Proven Results",
      desc: "Millions recovered for victims nationwide.",
      img: "/feature/proven-results.jpg",
      alt: "Proven results for mass-tort clients.",
    },
    {
      title: "Compassionate Support",
      desc: "We guide you at every step of your case.",
      img: "/feature/compassionate-support.jpg",
      alt: "Compassionate legal support.",
    },
  ];

  return (
    <section id="why-us" className="bg-[#F6FAFF] py-16">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-12 text-center">
          <span className="inline-block rounded-full bg-[#C89B3C]/20 px-4 py-1 text-sm font-semibold text-[#6b5a2a]">
            Why Choose Us
          </span>
          <h2 className="mt-2 text-4xl font-extrabold tracking-tight text-[#0A2540] md:text-4xl">
            A Legal Network You Can Trust
          </h2>

          <p className="mx-auto mt-3 max-w-2xl text-neutral-700">
            Connecting you with experienced attorneys dedicated to fighting for
            your rights.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {items.map((it, i) => (
            <Reveal key={it.title} delay={i * 120}>
              <article className="group overflow-hidden rounded-2xl border border-[#C89B3C]/40 bg-white shadow-sm transition-all duration-200 hover:-translate-y-1.5 hover:border-[#C89B3C] hover:shadow-lg">
                {/* Top banner image (shorter height) */}
                <div className="relative w-full overflow-hidden rounded-t-2xl">
                  <img
                    src={it.img}
                    alt={it.alt || it.title}
                    width="480"
                    height="270"
                    loading="lazy"
                    decoding="async"
                    className="h-36 w-full object-cover md:h-40 lg:h-44 transition-transform duration-300 group-hover:scale-[1.02]"
                  />
                  <div
                    className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-200 group-hover:opacity-100"
                    style={{
                      background:
                        "linear-gradient(to top, rgba(0,0,0,.18), rgba(0,0,0,0))",
                    }}
                    aria-hidden="true"
                  />
                </div>

                {/* Text (smaller) */}
                <div className="p-4 text-center">
                  <h3 className="text-base md:text-lg font-semibold text-[#0A2540]">
                    {it.title}
                  </h3>
                  <p className="mt-1.5 text-[13px] leading-relaxed text-neutral-700">
                    {it.desc}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
